import {Signup} from './signup';

Hop.defineModule('forms.signup', (root, param) => {
    const $root = $(root);
    const fieldIds = {
        email: 'email',
        password: 'password',
        firstName: 'firstName',
        lastName: 'lastName',
        legals: 'legals',
        optOutFromNews: 'optOutFromNews',
    };
    const signup = new Signup($root, fieldIds, param);
    storeSignup();

    function storeSignup() {
        Hop.storeObj(signup);
    }

    function destroySignup() {
        Hop.destroyObj(signup.id);
        signup.destroy();
    }

    return function destroy() {
        destroySignup();
    };
});
